import { msg, str } from "@lit/localize";
import { html, LitElement } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import "../icon";
import { styles as buttonStyle } from "../buttons/common.scss";
import style from './top-scroller.scss';
import "../navigation";

/**
 * Floating button providing quick scroll to top of the page.
 */
@customElement('top-scroller')
export class TopScroller extends LitElement {
    static override styles = [buttonStyle, style];

    /**
     * How many screenfuls should we scroll past before showing the button?
     */
    @property({attribute: 'min-screens', type: Number})
    minScreens = 1.2;

    @state()
    private isVisible = false;

    private boundScrollHandler = this._scrollHandler.bind(this);

    override connectedCallback(): void {
        super.connectedCallback();
        window.addEventListener('scroll', this.boundScrollHandler);
    }

    override disconnectedCallback(): void {
        super.disconnectedCallback();
        window.removeEventListener('scroll', this.boundScrollHandler);
    }

    private _scrollHandler() {
        this.isVisible = window.scrollY >= document.documentElement.clientHeight * this.minScreens;
    }

    private _scrollToTop() {
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    }

    override render() {
        return html`
            <div ?data-is-visible=${this.isVisible} class="usos-ui">
                <button @click=${this._scrollToTop} class="neutral outlined">
                    <usos-icon icon-name="arrow_upward"></usos-icon>
                    ${msg(str`Przewiń do góry`)}
                </button>
            </div>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'top-scroller': TopScroller,
    }
}
